



import React from 'react';
import PropTypes from 'prop-types';
import './HeadingSection.css';

const HeadingSection = ({ headingText }) => {
  return (
    <div className="heading-container">
      <h1 className="heading-text">{headingText}</h1>
    </div>
  );
};

HeadingSection.propTypes = {
  headingText: PropTypes.string.isRequired,
};

export default HeadingSection;
